import {UI} from "../../../../stem-core/ui/UIBase.js";
import {CheckboxInput} from "../../../../stem-core/ui/input/checkbox/CheckboxInput.jsx";
import {DashboardMoneyInput} from "../../../ui/input/DashboardMoneyInput.jsx";
import {Money} from "../../../../stem-core/localization/Money.js";
import {Button} from "../../../../stem-core/ui/button/Button.jsx";
import {DashboardSection, DashboardDescription} from "../../../common/DashboardSection.jsx";
import {SimpleTable} from "../../../ui/SimpleTable.jsx";
import {TrashCanIcon} from "../../../SVGElements";
import {DashboardRadio} from "../../../../core/ui/input/radio/RadioListInput.jsx";
import type {DonationOfferEditorState} from "./DonationOfferEditorState";
import type {ColumnTuple} from "../../../../stem-core/base/ColumnHandler";


interface DonationAmountOptionsInputOptions {
    state?: DonationOfferEditorState;
}

export class DonationAmountOptionsInput extends DashboardSection<DonationAmountOptionsInputOptions> {
    getDefaultOptions() {
        return {
            title: "Amount options",
        }
    }

    render() {
        const {state} = this.options;
        const predefinedAmounts = state.value.predefinedAmounts;
        const currency = state.donationOffer.currency;

        const tableColumns: ColumnTuple<number>[] = [
            ["Suggested amount", (value, index) => <DashboardMoneyInput
                initialValue={new Money(value, currency)}
                style={{width: 120}}
                onChange={(value) => {
                    state.setPredefinedAmount(index, value);
                }}
            />],
            ["Default", (value, index) => <div style={{display: "flex", margin: "auto"}}>
                <DashboardRadio
                    selected={state.value.defaultPredefinedAmountIndex === index}
                    onClick={() => state.update({defaultPredefinedAmountIndex: index})}
                />
                <TrashCanIcon
                    size={24}
                    style={{cursor: "pointer"}}
                    onClick={() => state.removePredefinedAmount(index)}
                />
            </div>]
        ];

        return [
            <CheckboxInput
                label="Allow custom amount"
                initialValue={state.value.allowCustomAmount}
                onChange={(value) => state.update({allowCustomAmount: value})}
            />,

            <DashboardDescription>
                Edit below the suggested amounts the user can choose. You can also edit which of these is selected by default.
            </DashboardDescription>,

            <SimpleTable<number>
                style={{width: 240}}
                entries={predefinedAmounts}
                columns={tableColumns}
            />,

            <Button
                disabled={predefinedAmounts.length >= 9}
                onClick={() => state.addNewPredefinedAmount()}
                label="New Amount" />,
        ]
    }
}